import { HOME_AGENT_SELECT_OPTIONS } from './homeAgentSelectOptions'
import { HOME_PERSONA_LEGACY_OPTIONS } from './homePersonaLegacyOptions'
import { HOME_PERSONA_SELECT_OPTIONS } from './homePersonaSelectOptions'

export const DEFAULT_ASK_BAR_AGENT_ID = 'software-engineer'
export const DEFAULT_ASK_BAR_PERSONA_ID = 'sales'

/** Offered personas plus the retired ids demo scripts still reference. */
const RESOLVABLE_PERSONAS = [...HOME_PERSONA_SELECT_OPTIONS, ...HOME_PERSONA_LEGACY_OPTIONS]

/** @param {string} [agentId] */
export function resolveAgentOption(agentId) {
  return (
    HOME_AGENT_SELECT_OPTIONS.find((o) => o.value === agentId) ??
    HOME_AGENT_SELECT_OPTIONS.find((o) => o.value === DEFAULT_ASK_BAR_AGENT_ID)
  )
}

/** @param {string} [personaId] */
export function resolvePersonaOption(personaId) {
  return (
    RESOLVABLE_PERSONAS.find((o) => o.value === personaId) ??
    HOME_PERSONA_SELECT_OPTIONS.find((o) => o.value === DEFAULT_ASK_BAR_PERSONA_ID)
  )
}

/** @param {string} [agentId] */
export function resolveAgentLabel(agentId) {
  return resolveAgentOption(agentId)?.label ?? 'Software Engineering'
}

/** @param {string} [personaId] */
export function resolvePersonaLabel(personaId) {
  return resolvePersonaOption(personaId)?.label ?? 'Sales'
}
